import sum from 'lodash/sum'

export const REFERRAL_LINKS_TABLE = {
  columnWidths: {
    introduceTo: 280,
    referralsBooked: 120,
    actions: 140,
  },

  get tableWidth() {
    return (
      sum(Object.values(this.columnWidths)) + 2 // (2px is for the borders)
    )
  },

  searchParams: {
    page: 'page',
  },

  pageSize: 5,
}
